import { OUTPUT_REVIEW_VERSION, OUTPUT_REVIEW_MODELS } from './output-review-policy.js';

// Shared browser/server contract. Only the server creates and approves reviews.
export const INPUT_REVIEW_VERSION = 'botgo-input-review-v1';
export const CONTENT_REVIEW_FAILED = 'Content moderation failed. Please revise your prompt or input media. No credits were charged.';
export const CONTENT_REVIEW_UNAVAILABLE = 'Content moderation is temporarily unavailable. Please try again. No credits were charged.';

export function isBotgoContentFilteringModel(modelKey) {
  return /^botgo-(?:video|image)-/.test(String(modelKey || ''));
}

export function canDisableContentFiltering(subscription, now = Date.now()) {
  const plan = subscription?.plan;
  const periodEnd = new Date(subscription?.currentPeriodEnd || subscription?.endDate || '').getTime();
  return ['active', 'upgrading'].includes(subscription?.status)
    && Number.isFinite(periodEnd) && periodEnd > Number(now)
    && Number(plan?.tier) >= 2
    && ['monthly', 'yearly'].includes(plan?.billingCycle);
}

export function createInputReviewSnapshot({ modelKey, noContentFiltering, subscription } = {}) {
  if (!isBotgoContentFilteringModel(modelKey)) return null;
  if (noContentFiltering === undefined) noContentFiltering = canDisableContentFiltering(subscription);
  if (typeof noContentFiltering !== 'boolean') {
    const error = new Error('No Content Filtering must be a boolean.');
    error.code = 'INVALID_CONTENT_FILTERING';
    throw error;
  }
  if (noContentFiltering && !canDisableContentFiltering(subscription)) {
    const error = new Error('An active Pro or higher monthly or yearly subscription is required.');
    error.code = 'CONTENT_FILTERING_PRO_REQUIRED';
    throw error;
  }
  return { version: INPUT_REVIEW_VERSION, state: noContentFiltering ? 'skipped' : 'pending',
    noContentFiltering,
    ...(OUTPUT_REVIEW_MODELS.includes(modelKey) && !noContentFiltering
      ? { outputReviewVersion: OUTPUT_REVIEW_VERSION, outputReviewRequired: true } : {}),
    selectedAt: new Date().toISOString() };
}
